// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1957f648","455":"136b192f","977":"d554988b"}[chunkId] + ".chunk.js";
};